import WelcomeSvg from '@/assets/WelcomeSvg.svg';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

const ServiceUnavailableView: React.FC = () => {
  const { t } = useTranslationWithPrefix('views.serviceUnavailable');

  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-h-screen px-4 mx-auto pb-32 sm:pb-0">
      <div className="d-flex flex-column align-items-center" style={{ maxWidth: '800px' }}>
        <img
          alt="welcome-robot"
          className="w-100 h-auto mb-5"
          src={WelcomeSvg}
          style={{ maxWidth: '600px' }}
        />
        <h1 className="display-2 text-primary text-center fw-bold">{t('message')}</h1>
      </div>
    </div>
  );
};

export default ServiceUnavailableView;
